import { render, staticRenderFns } from "./EditBill.vue?vue&type=template&id=516058ec"
import script from "./EditBill.vue?vue&type=script&lang=js"
export * from "./EditBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports